module.exports = __webpack_public_path__ + "static/img/customer-risk.dcb5916.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/customer-risk.png
// module id = E4Rf
// module chunks = 1